<template>
  <div class="body-box marginBox">
    <!-- 搜索与添加区域 -->
    <el-row class="plan">
      <el-col :span="19">
        <el-button icon="el-icon-plus" @click="addGoods">新增</el-button>
      </el-col>

      <el-col :span="5">
        <search-input v-model="queryInfo.keyword" placeholder="请输入关键字进行搜索" @change="handleQuery"/>
      </el-col>

    </el-row>

    <el-table :height="'calc(100% - 70px)'" :data="goodsList" class="button-box">
      <el-table-column label="缩略图" prop="thumbnail">
        <template slot-scope="scope">
          <icon-img :icon="scope.row.thumbnail"></icon-img>
        </template>
      </el-table-column>
      <el-table-column label="商品名" prop="name"></el-table-column>
      <el-table-column label="分类" prop="classifyDict">
        <template slot-scope="scope">
            <span v-for=" data in scope.row.classifyDict" :key="data.id">
              {{ data.value }} ,
            </span>
        </template>
      </el-table-column>
      <el-table-column label="品牌" prop="brandDict.value"></el-table-column>
      <el-table-column label="获得积分" prop="integral"></el-table-column>
      <el-table-column label="数量" prop="num"></el-table-column>
      <el-table-column label="所需积分" prop="score"></el-table-column>
      <el-table-column label="推荐排序" prop="resort"></el-table-column>
      <el-table-column label="上架/下架" prop="resort">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.enumStatus"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-value="NORMAL"
            inactive-value="SOLD_OUT"
            @change="updateGoodsStatus(scope.row.id,scope.row.enumStatus)">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="100" fixed="right">
        <template slot-scope="scope">
          <el-popover placement="right" trigger="click">
            <div class="foldBtnBox">
              <div><el-button icon="el-icon-edit" @click="viewGoods(scope.row)">查看</el-button></div>
              <div><el-button icon="el-icon-view" @click="qrCode(scope.row)">商品二维码</el-button></div>
              <div><el-button icon="el-icon-edit" @click="editGoods(scope.row)">修改</el-button></div>
              <div><el-button icon="el-icon-delete" @click="removeGoodsById(scope.row.id)">删除</el-button></div>
            </div>
            <el-button slot="reference">更多操作</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页区域 -->
    <div class="fixedBox"><pagination ref='page' :query-param.sync='queryInfo' @pagination='getGoodsList'></pagination></div>
    <goods-qr-code ref='qrCode'></goods-qr-code>
  </div>
</template>
<script>
import { getData, getPostOrDeleteData } from '@/utils/code'
import { deleteGoods, getGoodsList, updateGoodsStatus } from '@/api/goods/goods'
import SearchInput from '@/components/common/searchInput/searchInput'
import IconImg from '@/components/common/pictureImg/index'
import Pagination from '@/components/common/Pagination/index'
import GoodsQrCode from '@/views/goods/GoodsQrCode.vue'


export default {
  components: { IconImg, SearchInput, Pagination, GoodsQrCode },
  data() {
    return {
      queryInfo: {keyword: ''},
      goodsList: []
    }
  },
  created() {
    this.handleQuery()
  },
  methods: {
    // 上下架商品
    updateGoodsStatus(id,status){
      updateGoodsStatus(id,status).then((res)=>{
          let data = getData(res)
          if(data){
            let msg = status==='NORMAL'?'上架成功!':'下架成功!'
            this.$message.success(msg)
            this.getGoodsList()
          }
      })
    },

    //查询列表
    getGoodsList(page, cb) {
      getGoodsList(page).then((res) => {
        this.goodsList = cb(res)
      })
    },

    handleQuery() {
      this.$nextTick(() => {
        this.$refs.page.run()
      })
    },

    //根据ID删除数据
    removeGoodsById(id) {
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteGoods(id).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.getGoodsList()
          }
        })
      }).catch(() => {})
    },

    //新增
    addGoods() {
      this.$router.push('/addGoods')
    },

    //查看详情
    viewGoods(row) {
      this.$router.push({
        path: '/viewGoods',
        query: {
          id: row.id
        }
      })
    },
    // 商品二维码
    qrCode(row) {
      this.$refs['qrCode'].open(row)
    },

    //修改
    editGoods(row) {
      this.$router.push({
        path: '/editGoods',
        query: {
          id: row.id
        }
      })
    },

  }
}
</script>

<style lang="less" scoped>

</style>
